<template>
	<div class="bg-gray-100 NOTh-screen min-h-full">
		<layout-admin-top-nav />
		<Analytics title="Admin" />
		<clear-session-storage />
		<main>
			<ui-alert
				v-if="flashMessage"
				:type="flashMessage.type"
				:message="flashMessage.message"
			/>
			<slot />
			<layout-modal-container />
			<ui-modal-dialog />
		</main>
	</div>
</template>

<script>
import ClearSessionStorage from "../ClearSessionStorage.vue";
import toast from "../../services/toast";

export default {
	components: { ClearSessionStorage },

	props: {
		flashMessage: {
			type: Object,
			required: false,
			default: null,
		},
	},

	mounted() {
		this.$bus.$on("toast", this.showToast);
	},

	beforeDestroy() {
		this.$bus.$off("toast", this.showToast);
	},

	methods: {
		/**
		 * @param {{ type: string, message: string }} payload
		 * @return {void}
		 */
		showToast({ type, message }) {
			if (this.$toast[type]) {
				this.$toast[type](message);
			} else {
				this.$toast(message);
			}
		},
	},
};
</script>
